export default __webpack_public_path__ + "static/media/teamIcon.384b031e.svg";